/**
 * Data Streamer API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

// @ts-ignore
import { GetSnapshotById200Response } from '../model/get-snapshot-by-id200-response';
import { Param } from '../param';
import { ApiConfigurationService } from '../../helpers/api-configuration.service';
import { HttpParamHelper } from '../../helpers/http-param-helper';
import { CustomHttpParameterCodec } from '../encoder';

import { COLLECTION_FORMATS } from '../variables';

@Injectable({
  providedIn: 'root',
})
export class SnapshotControllerService {
  private readonly encoder: CustomHttpParameterCodec;
  private readonly httpClient = inject(HttpClient);
  protected readonly configuration = inject(ApiConfigurationService);

  constructor() {
    this.encoder = this.configuration.encoder;
  }

  public getSnapshotById(
    id: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<GetSnapshotById200Response>;
  public getSnapshotById(
    id: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<GetSnapshotById200Response>>;
  public getSnapshotById(
    id: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<GetSnapshotById200Response>>;
  public getSnapshotById(
    id: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getSnapshotById.');
    }
    return this.httpClient.request<GetSnapshotById200Response>(
      'get',
      `/data/snapshots/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      {
        responseType: 'application/json'.startsWith('text/') ? ('text' as 'json') : undefined,
        observe: observe,
      },
    );
  }
}
